import { ButtonIcon, Flex, IconX, Modal, Text } from '@cmpsr/components';
import { FC } from 'react';
import { type QuestionTitleModalProps } from './types';

// TODO: This should be extracted and shared somewhere but I am not sure where
const MOBILE_NEXT_BUTTON_HEIGHT = '50px';
const DESKTOP_FOOTER_HEIGHT = '81px';

export const QuestionTitleModal: FC<QuestionTitleModalProps> = ({ modalIsOpen, onClose, content }) => {
  return (
    <Modal isOpen={modalIsOpen} onClose={onClose}>
      <Modal.Overlay bg="background-overlay" />
      <Modal.Content
        borderRadius="radii-6"
        borderBottomRadius="0"
        alignSelf="end"
        mb={{ base: MOBILE_NEXT_BUTTON_HEIGHT, md: DESKTOP_FOOTER_HEIGHT }}
      >
        <Modal.Header borderRadius="radii-6">
          <Flex justifyContent="center">
            <Text variant="text-body-large-medium">Why we ask</Text>
          </Flex>
        </Modal.Header>
        <Modal.Body
          w={{ base: '335px', md: '460px', lg: '540px', xl: '600px' }}
          maxHeight="calc(100svh - 80px - 86px - 66px - 64px)" // 80px = page footer, 86px = modal footer, 66px = modal header, 64px = top spacing
          py="spacer-1"
          overflow="auto"
        >
          <Text variant="text-body-regular" color="text-secondary">
            {content}
          </Text>
        </Modal.Body>
        <Modal.Footer justifyContent="center" py={6}>
          <ButtonIcon
            variant="ghost"
            size="s"
            onClick={onClose}
            borderColor="primary-default"
            borderRadius="50%"
            borderStyle="solid"
            borderWidth="1px"
            aria-label="Close"
            icon={<IconX size="s" />}
          />
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};
